import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { CHECK_OLD_PASSWORD } from './actionTypes';
import { checkOldPasswordDone, checkOldPasswordError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* checkOldPasswordCall(constAccessParams, action) {
    const { password } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.checkOldPass, newAccessParams, password);
    if (isSuccessResponse(result)) {
        yield put(checkOldPasswordDone({ password }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(checkOldPasswordError(result));
    }
}
export function* watchCheckOldPasswordCall(constAccessParams) {
    yield takeLatest(CHECK_OLD_PASSWORD, checkOldPasswordCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map